<template>
    <b-container class="m-3">
        <b-row>
            <b-col>
                <p class="h4">
                    <strong>Amenities and More</strong>
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-container>
                <!-- list -->
                <b-row>
                    <b-col>
                        <AmenitiesOption 
                            icon="bag" 
                            name="Offers Takeout" 
                            disabled="false"
                        />
                    </b-col>
                    <b-col>
                        <AmenitiesOption 
                            icon="calendar3" 
                            name="No Reservations" 
                            disabled="false"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <AmenitiesOption 
                            icon="bicycle" 
                            name="No Delivery" 
                            disabled="false"
                        />
                    </b-col>
                    <b-col>
                        <AmenitiesOption 
                            icon="credit-card" 
                            name="Accepts Credit Cards"
                            disabled="false" 
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <AmenitiesOption 
                            icon="person" 
                            name="Casual" 
                            disabled="false"
                        />
                    </b-col>
                    <b-col>
                        <AmenitiesOption 
                            icon="volume-up" 
                            name="Moderate Noise" 
                            disabled="false"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <AmenitiesOption 
                            icon="people" 
                            name="Good for Groups" 
                            disabled="false"
                        />
                    </b-col>
                    <b-col>
                        <AmenitiesOption 
                            icon="joystick" 
                            name="Good For Kids" 
                            disabled="false"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <AmenitiesOption 
                            icon="hand-thumbs-up" 
                            name="Good for Lunch, Dinner" 
                            disabled="false"
                        />
                    </b-col>
                    <b-col>
                        <AmenitiesOption 
                            icon="pen" 
                            name="Waiter Service" 
                            disabled="false"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <AmenitiesOption 
                            icon="tv" 
                            name="TV" 
                            disabled="false"
                        />
                    </b-col>
                    <b-col>
                        <AmenitiesOption 
                            icon="sun" 
                            name="No Outdoor Seating" 
                            disabled="false"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <AmenitiesOption 
                            icon="wifi" 
                            name="No Wi-Fi" 
                            disabled="false" 
                        />
                    </b-col>
                    <b-col>
                        <AmenitiesOption 
                            icon="cup-straw" 
                            name="No Alcohol" 
                            disabled="true" 
                        />
                    </b-col>
                </b-row>
            </b-container>
        </b-row>
        <b-row>
            <b-col>
                <b-button variant="outline-primary">Show Less</b-button>
            </b-col>
        </b-row>
    </b-container>
</template>

<style scoped>

</style>

<script>
import AmenitiesOption from './AmenitiesOption'

export default {
    components: {
        AmenitiesOption
    }
}
</script>